import React, { Component } from 'react';
import './Section.css';
import PageTitle from '../content-blocks/PageTitle/PageTitle';
import Tile from '../content-blocks/Tile/Tile';
import ContentSlider from '../ContentSlider/ContentSlider';
import Banner from '../content-blocks/Banner/Banner';
import Products from '../content-blocks/Products/Products';
import Separator from '../content-blocks/Separator/Separator';
import Html from '../content-blocks/Html/Html';
import Video from '../content-blocks/Video/Video';
import Recommendations from '../content-blocks/Recommendations/Recommendations';
import Collage from '../content-blocks/Collage/Collage';

const Wrapper = props => {
  if (props.sectionConfig.swipeable) {
    return (
      <ContentSlider size={props.sectionConfig.size}>
        {props.children}
      </ContentSlider>
    );
  } else {
    return <React.Fragment>{props.children}</React.Fragment>;
  }
};

class Section extends Component {
  contentBlock(b) {
    switch (b.type) {
      case 'page-title':
        return (
          <PageTitle contentBlock={b} storeConfig={this.props.storeConfig} />
        );
      case 'tile':
        return (
          <Tile
            className={b.type}
            contentBlock={b}
            storeConfig={this.props.storeConfig}
          />
        );
      case 'shop-the-range':
        return (
          <Tile
            className={b.type}
            contentBlock={b}
            storeConfig={this.props.storeConfig}
          />
        );
      case 'banner':
        return <Banner contentBlock={b} storeConfig={this.props.storeConfig} />;
      case 'products':
        return (
          <Products contentBlock={b} storeConfig={this.props.storeConfig} />
        );
      case 'recommendations':
        return <Recommendations contentBlock={b} />;
      case 'separator':
        return <Separator contentBlock={b} />;
      case 'html':
        return <Html contentBlock={b} />;
      case 'video':
        return <Video contentBlock={b} />;
      case 'collage':
        return (
          <Collage
            className={b.type}
            contentBlock={b}
            storeConfig={this.props.storeConfig}
          />
        );
      default:
        return (
          <div className="content-block">
            <span>{b.title}</span>
            <span> ({b.type})</span>
          </div>
        );
    }
  }

  render() {
    if (
      !Array.isArray(this.props.contentBlocks) ||
      !(this.props.sectionIdx >= 0) ||
      !this.props.storeConfig ||
      !this.props.sectionConfig
    ) {
      return null;
    }

    const { size, swipeable, noMargins } = this.props.sectionConfig;

    return (
      <div
        className={`section ${size} ${swipeable ? 'swipeable' : ''} ${
          noMargins ? 'no-margins' : ''
        }`}
      >
        <Wrapper {...this.props}>
          {this.props.contentBlocks.map((block, idx) => (
            <React.Fragment
              key={`content-block-${this.props.sectionIdx}-${idx}`}
            >
              {this.contentBlock(block)}
            </React.Fragment>
          ))}
        </Wrapper>
      </div>
    );
  }
}

export default Section;
export { Wrapper };



// WEBPACK FOOTER //
// ./src/components/Section/Section.js